import { render, staticRenderFns } from "./modal-table.vue?vue&type=template&id=09330e25&"
import script from "./modal-table.vue?vue&type=script&lang=js&"
export * from "./modal-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports